
import React, { useState } from 'react';
import { Navigate, Link, useNavigate } from 'react-router-dom';
import { doSignInWithEmailAndPassword, doSignInWithGoogle } from '../../../firebase/auth';
import { useAuth } from '../../../contexts/authContext';
import { makeAuthenticatedRequest } from '../../../utils/apiRequest';
import { doPasswordReset } from '../../../firebase/auth';
const Login = () => {
    const { userLoggedIn } = useAuth();
    const navigate = useNavigate(); // Correctly initialize navigate

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isSigningIn, setIsSigningIn] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [showForgotPasswordPopup, setShowForgotPasswordPopup] = useState(false);
const [resetEmail, setResetEmail] = useState("");
const [resetMessage, setResetMessage] = useState("");
  const [message, setMessage] = useState("");

    let token = ''; // Declare token here

    const setupTokenRefresh = (user) => {
        // Refresh token every 50 minutes
        const interval = setInterval(async () => {
            try {
                const freshToken = await user.getIdToken(true); // Force token refresh
                console.log("Lotgin Token refreshed:", freshToken);
                token = freshToken; // Update the token variable
            } catch (error) {
                console.error("Error during token refresh:", error);
            }
        }, 50 * 60 * 1000); // 50 minutes

        // Clear interval when the component unmounts
        return () => clearInterval(interval);
    };


    const onSubmit = async (e) => {
        e.preventDefault();
        if (!isSigningIn) {
            setIsSigningIn(true);

            try {
                const userCredential = await doSignInWithEmailAndPassword(email, password);
                const user = userCredential.user;

                token = await user.getIdToken(true); // Ensure the token is fresh
                console.log("Firebase Token:", token);

                setupTokenRefresh(user); // Start refreshing the token every 50 minutes

                const response = await makeAuthenticatedRequest(
                    "https://us-central1-evoq-travel-craft.cloudfunctions.net/init_mail_user",
                    {
                        method: "POST",
                        body: JSON.stringify({ token }),
                    }
                );

                const userDetails = await response.json();
                console.log("User Details:", userDetails);

                navigate("/user", { state: { token } });
            } catch (error) {
                console.error("Login Error:", error.message);
                setErrorMessage(error.message);
            } finally {
                setIsSigningIn(false);
            }
        }
    };


    const onGoogleSignIn = async (e) => {
        e.preventDefault();
        if (!isSigningIn) {
            setIsSigningIn(true);

            try {
                const userCredential = await doSignInWithGoogle();
                const user = userCredential.user;

                token = await user.getIdToken();
                console.log("Firebase Token:", token);

                setupTokenRefresh(user); // Start refreshing the token every 50 minutes

                const response = await fetch('https://us-central1-evoq-travel-craft.cloudfunctions.net/init_mail_user', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({ token }),
                });

                if (!response.ok) {
                    throw new Error(`Error: ${response.statusText}`);
                }

                const userDetails = await response.json();
                console.log("User Details:", userDetails);

                navigate('/user', { state: { token } });
            } catch (error) {
                console.error("Error:", error.message);
                setErrorMessage(error.message);
            } finally {
                setIsSigningIn(false);
            }
        }
    };

    const handlePasswordReset = async () => {
        if (!resetEmail) {
          setResetMessage("Please enter your email address.");
          return;
        }
      
        try {
          await doPasswordReset(resetEmail);
          setResetMessage("Password reset email sent. Check your inbox.");
        } catch (error) {
          console.error("Error resetting password:", error.message);
          setResetMessage("Failed to send password reset email.");
        }
      };
     
    return (
        <div>
            {userLoggedIn && <Navigate to="/user" replace />}

            <main className="w-full h-screen flex self-center place-content-center place-items-center">
                <div className="w-96 text-gray-600 space-y-5 p-4 shadow-xl border rounded-xl">
                    <div className="text-center">
                        <h3 className="text-gray-800 text-xl font-semibold sm:text-2xl">Welcome Back</h3>
                    </div>
                    <form onSubmit={onSubmit} className="space-y-5">
                        <div>
                            <label className="text-sm text-gray-600 font-bold">Email</label>
                            <input
                                type="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:border-indigo-600 shadow-sm rounded-lg"
                            />
                        </div>

                        <div>
                            <label className="text-sm text-gray-600 font-bold">Password</label>
                            <input
                                type="password"
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:border-indigo-600 shadow-sm rounded-lg"
                            />
                        </div>

                  

                        {errorMessage && <span className="text-red-600 font-bold">{errorMessage}</span>}

                        <button
                            type="submit"
                            disabled={isSigningIn}
                            className={`w-full px-4 py-2 text-white font-medium rounded-lg ${
                                isSigningIn
                                    ? 'bg-gray-300 cursor-not-allowed'
                                    : 'bg-indigo-600 hover:bg-indigo-700 hover:shadow-xl transition'
                            }`}
                        >
                            {isSigningIn ? 'Signing In...' : 'Sign In'}
                        </button>
                    </form>
                    <button
  type="button"
  onClick={() => setShowForgotPasswordPopup(true)}
  className="text-blue-500 mt-2 underline"
>
  Forgot Password?
</button>

{showForgotPasswordPopup && (
  <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center">
    <div className="bg-white p-6 rounded-lg shadow-xl">
      <h2 className="text-lg font-semibold">Reset Password</h2>
      <input
        type="email"
        placeholder="Enter your email"
        value={resetEmail}
        onChange={(e) => setResetEmail(e.target.value)}
        className="w-full p-2 border rounded mt-2"
      />
      <button
        onClick={handlePasswordReset}
        className="bg-indigo-600 text-white px-4 py-2 rounded mt-2"
      >
        Send Reset Email
      </button>
      <button
        onClick={() => setShowForgotPasswordPopup(false)}
        className="ml-2 bg-gray-400 text-white px-4 py-2 rounded"
      >
        Close
      </button>
      {resetMessage && <p className="mt-2 text-sm text-gray-600">{resetMessage}</p>}
    </div>
  </div>
)}

                    <p className="text-center text-sm">
                        Don't have an account?{' '}
                        <Link to="/register" className="hover:underline font-bold">
                            Sign up
                        </Link>
                    </p>
                    <div className="flex items-center gap-x-2">
                        <div className="border-b w-full"></div>
                        <span className="text-sm font-bold">OR</span>
                        <div className="border-b w-full"></div>
                    </div>
                    <button
                        disabled={isSigningIn}
                        onClick={onGoogleSignIn}
                        className={`w-full flex items-center justify-center gap-x-3 py-2.5 border rounded-lg text-sm font-medium ${
                            isSigningIn ? 'cursor-not-allowed' : 'hover:bg-gray-100'
                        }`}
                    >
                        <svg className="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
                            
                        </svg>
                        {isSigningIn ? 'Signing In...' : 'Continue with Google'}
                    </button>
                </div>
            </main>
        </div>
    );
};

export default Login;